import { render } from "./Admin.Users.vue?vue&type=template&id=f1c3f5d4"
import script from "./Admin.Users.vue?vue&type=script&lang=js"
export * from "./Admin.Users.vue?vue&type=script&lang=js"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__